export const FALLBACK_COLOR = "#CACACA";

// The percentile series get their own palette per the design. The API sends the
// brand pink pair for them, so these take precedence over the payload's color
// rather than filling in for a missing one.
const PERCENTILE_SERIES_COLORS: Record<string, string> = {
  p50: "#00E6D7",
  p25: "#3A45D8"
};

export const getPercentileSeriesColor = (
  key: string,
  apiColor?: string | null
): string => PERCENTILE_SERIES_COLORS[key] ?? apiColor ?? FALLBACK_COLOR;

// Labelled by the card rather than the payload: the two percentile endpoints
// name the same series differently ("Median (P50)" vs "P50"), and the graphs
// sit next to each other.
const PERCENTILE_SERIES_LABELS: Record<string, string> = {
  p50: "P50",
  p25: "P25"
};

export const getPercentileSeriesLabel = (
  key: string,
  apiLabel?: string | null
): string => PERCENTILE_SERIES_LABELS[key] ?? apiLabel ?? key;

// Ascending percentile, so the legend and tooltip read P25 before P50. Series
// the map doesn't know keep the payload's order, after the ones it does.
const PERCENTILE_ORDER = ["p25", "p50"];

const percentileRank = (key: string) => {
  const idx = PERCENTILE_ORDER.indexOf(key);
  return idx === -1 ? PERCENTILE_ORDER.length : idx;
};

export const orderPercentileSeries = <T extends { key: string }>(
  series: T[]
): T[] =>
  [...series].sort((a, b) => percentileRank(a.key) - percentileRank(b.key));
